export default "__VITE_ASSET__B_aVl82d__"